import { render, staticRenderFns } from "./ArticlesListPage.vue?vue&type=template&id=15480afd&scoped=true&"
import script from "./ArticlesListPage.vue?vue&type=script&lang=ts&"
export * from "./ArticlesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ArticlesListPage.vue?vue&type=style&index=0&id=15480afd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15480afd",
  null
  
)

export default component.exports